<div *ngIf="results && results.length > 0 && !reloadSearching" class="search-results col-12">
  <!-- Replicar este div para cada ubicacion -->
  <div class="header row mt-2 d-flex align-items-center justify-content-between" *ngIf="origin=='MULTIDESTINATION'">
    <div class="col-2 pl-1 text-left">
      <h6>{{category}} Destiny:
        <span>{{payload.destination}}</span>
      </h6>
      <!-- Colocar destino en el span -->
    </div>

    <div class="col-4 center-block" *ngIf="payload">
      <usb-item-selected [destino]="results.destination" (collapse)="closeCollapse($event)" [categoryName]="categoryName"
        [payload]="payload"></usb-item-selected>
    </div>

    <div class="col-1 center-block">
      <div *ngIf="tabSelected=='TRANSPORTS' && ori!== undefined ">
        <button class="btn btn-sm btn-usblick-pink justify-content-center my-1" (click)="ModalRooms.show()">
          <i class="icon-edit icon fas fa-search"></i>
        </button>
        <usb-modals-search bsModal #ModalRooms="bs-modal" class="modal  zindex fade" tabindex="-1" role="dialog" aria-hidden="true"
          [modalRoomRef]="ModalRooms" [_ori]="ori" [origin]="tabSelected" [cityIataCode]="payload.destination"
          (emitReload)="reloadSearch($event, false, true)" (isLoading)="_onLoading($event)">
        </usb-modals-search>
      </div>
    </div>
    <div class="col-1 text-center">
      <button class="btn-acordeon" (click)="toggleCollapse()"><i class="fas"
          [ngClass]="{'fa-chevron-up': contentCollapsed,'fa-chevron-down': !contentCollapsed}"></i>
      </button>
    </div>
  </div>

  <p class="head-subtitle mb-2" style="font-size: 12px; font-weight: 400; padding: 0px 30px;">Resultados de Búsqueda</p>

  <div class="header row d-flex mb-2" style="border: 1px solid #e0e0e0;" *ngIf="origin!='MULTIDESTINATION'"  [ngStyle]="{'background-color': headerStyle?.background_color_header}">
    <div class="d-flex flex-column" style="width: 95%; padding: 20px 30px !important;">
      <h6 *ngIf=" origin == 'HOTELS'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Hoteles en {{cityNameForm?.destination?.city_name}}</h6>
      <h6 *ngIf=" origin === 'FLIGHTS'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Vuelos en {{cityNameForm?.legs[0]?.origin?.city_name}}</h6>
      <h6 *ngIf=" origin == 'RENT-A-CAR'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Rent a car en {{cityNameForm?.origin?.name}}</h6>
      <h6 *ngIf=" origin == 'TOURS' && categoryId == 6" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Experiencia en {{cityNameForm.destination.city_name}}</h6>
      <h6 *ngIf=" origin == 'TOURS' && categoryId == 9" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Tickets en {{cityNameForm.destination.city_name}}</h6>
      <h6 *ngIf=" origin == 'INSURANCE'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Asistencia al viajero</h6>
      <h6 *ngIf=" origin == 'BOATS'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Yates en {{cityNameForm?.destination?.city_name}}</h6>
      <h6 *ngIf=" origin == 'TRANSPORTS'" class="head-title m-0 mb-2" [ngStyle]="{'color': headerStyle?.color}">Traslado de {{extractNameTransport(formTransports.firstOrigin, 'origin', true)}} > {{extractNameTransport(formTransports.firstDestination, 'destination', true)}} <span *ngIf="!payload.transfers.oneWay">(Ida y vuelta)</span></h6>
      <div class="d-flex" *ngIf="origin == 'HOTELS' ">
        <span class="head-subtitle" [ngStyle]="{'color':headerStyle?.color }"> In: {{arrivalDate | date:'dd - MMM - YY'}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Out: {{departureDate | date:'dd - MMM - YY'}} ({{getNights(arrivalDate, departureDate)}})</span>
         <span class="d-flex ml-5" style="gap: 10px;">
            <div class="d-flex align-items-center">
              <img src="../../../assets/icons/itinerary/cama_peq.svg" class="ml-2" style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{payload.others?.hotels?.roomConfiguration?.length }} Habitación</p>
            </div>
            <div  class="d-flex align-items-center ml-2">
               <img src="../../../assets/icons/itinerary/adulto_pasajeros_peq.svg" class="ml-2"  style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ getPaxesRooms(payload.others?.hotels, 'adults')}} Adultos</p>
            </div>
            <div class="d-flex align-items-center ml-2">
               <img src="../../../assets/icons/itinerary/niño_peq.svg" class="ml-2" style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ getPaxesRooms(payload.others?.hotels, 'childs') }} Niños</p>
            </div>
         </span>
       </div>

      <div class="d-flex align-items-center" *ngIf="origin == 'FLIGHTS'">
        <div class="d-flex" >
          <span class="head-subtitle" [ngStyle]="{'color': headerStyle?.color}">INICIO: {{payload.legs[0]?.date | date:'dd-MMM-YY'}} </span>
          <!-- <span *ngIf="payload.transfers.dropoffTime" class="head-subtitle ml-2" [ngStyle]="{'color': headerStyle?.color}">VUELTA: {{payload.dropoffDate | date:'dd-MMM-YY'}}  ({{payload.transfers.dropoffTime}} hs. - {{getMessageFirstTime(payload.transfers.dropoffLocation, 'destination')}})</span> -->
        </div>

        <span class="d-flex ml-5" style="gap: 10px;" [ngClass]="{
              'ml-3': payload?.transfers?.dropoffTime,
              'ml-5': !payload?.transfers?.dropoffTime
              }">
            <div class="d-flex align-items-center">
              <img src="../../../assets/icons/itinerary/adulto_pasajeros_peq.svg" class="ml-2"  style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.others?.tours?.adults}} Adultos</p>
            </div>
            <div class="d-flex align-items-center">
              <img src="../../../assets/icons/itinerary/niño_peq.svg" class="ml-2" style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.others?.tours?.children?.length }} Niños</p>
            </div>
         </span>
      </div>

       <div class="d-flex" *ngIf="origin == 'TOURS' ">
         <span class="head-subtitle" [ngStyle]="{'color': headerStyle?.color}"> IN: {{payload.arrivalDate | date:'dd-MMM-YY'}}  </span>
         <span class="head-subtitle ml-2" [ngStyle]="{'color': headerStyle?.color}">| OUT: {{payload.departureDate | date:'dd-MMM-YY'}} </span>
       </div>

       <div class="d-flex" *ngIf="origin == 'RENT-A-CAR' ">
         <span class="head-subtitle" [ngStyle]="{'color': headerStyle?.color}"> PICK UP: {{payload.others.carRental.pickupLocation.pickupDate | date:'dd-MMM-YY'}}  </span>
         <span class="head-subtitle ml-2" [ngStyle]="{'color': headerStyle?.color}">| DROPP OFF: {{payload.others.carRental.dropoffLocation.dropoffDate | date:'dd-MMM-YY'}} </span>
         <span class="head-subtitle ml-2" [ngStyle]="{'color': headerStyle?.color}"> ({{getDays(payload.others.carRental.pickupLocation.pickupDate, payload.others.carRental.dropoffLocation.dropoffDate)}}) </span>
       </div>

       <div class="d-flex align-items-center" *ngIf="origin == 'TRANSPORTS' ">
        <div class="d-flex" >
          <span class="head-subtitle" [ngStyle]="{'color': headerStyle?.color}">INICIO: {{payload.pickupDate | date:'dd-MMM-YY'}}  ({{payload.transfers.pickupTime}} hs. - {{getMessageFirstTime(payload.transfers.pickupLocation, 'origin')}})</span>
          <span *ngIf="payload.transfers.dropoffTime" class="head-subtitle ml-2" [ngStyle]="{'color': headerStyle?.color}">VUELTA: {{payload.dropoffDate | date:'dd-MMM-YY'}}  ({{payload.transfers.dropoffTime}} hs. - {{getMessageFirstTime(payload.transfers.dropoffLocation, 'destination')}})</span>
        </div>

        <span class="d-flex ml-5" style="gap: 10px;" [ngClass]="{
              'ml-3': payload?.transfers?.dropoffTime,
              'ml-5': !payload?.transfers?.dropoffTime
              }">
            <div class="d-flex align-items-center">
              <img src="../../../assets/icons/itinerary/adulto_pasajeros_peq.svg" class="ml-2"  style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.transfers?.paxList?.adults}} Adultos</p>
            </div>
            <div class="d-flex align-items-center">
              <img src="../../../assets/icons/itinerary/niño_peq.svg" class="ml-2" style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.transfers?.paxList?.children?.length }} Niños</p>
            </div>
         </span>
      </div>

      <div class="d-flex" *ngIf="origin == 'BOATS' ">
        <span class="head-subtitle" [ngStyle]="{'color':headerStyle?.color }"> In: {{payload?.arrivalDate | date:'dd - MMM - YY'}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Out: {{payload?.departureDate | date:'dd - MMM - YY'}}</span>
        <span class="d-flex ml-5" style="gap: 10px;">
          <div class="d-flex align-items-center">
            <img src="../../../assets/icons/itinerary/adulto_pasajeros_peq.svg" class="ml-2" style="width: 18px;" alt="">
            <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.boats?.adults }} Adultos</p>
          </div>
          <div class="d-flex align-items-center ml-2">
            <img src="../../../assets/icons/itinerary/niño_peq.svg" class="ml-2" style="width: 18px;" alt="">
            <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{ payload?.boats?.children?.length }} Niños</p>
          </div>
        </span>
      </div>

      <div class="d-flex" *ngIf="origin == 'INSURANCE' ">
         <span class="head-subtitle" [ngStyle]="{'color':headerStyle?.color }"> In: {{payload?.dateBegin | date:'dd - MMM - YY'}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Out: {{payload?.dateEnd | date:'dd - MMM - YY'}}</span>

         <span class="head-subtitle ml-5" [ngStyle]="{'color':headerStyle?.color }">{{payload?.insurances?.destination}}</span>


         <span class="d-flex align-items-center ml-5">
            <div  class="d-flex align-items-center ml-2">
              <img src="../../../assets/icons/itinerary/adulto_pasajeros_peq.svg" class="ml-2"  style="width: 18px;" alt="">
              <p class="mb-0 ml-1 head-subtitle" [ngStyle]="{'color': headerStyle?.color_2}">{{payload?.insurances?.paxList[0]?.qtyPax}} {{payload?.insurances?.paxList[0]?.qtyPax === 1 ? 'Pasajero' : 'Pasajeros'}}</p>
            </div>
         </span>
       </div>
    </div>

    <div class="h-100" style="width: 5%; position: relative;">
      <button (click)="reloadEditPencilSearch()"

              class="d-flex justify-content-center align-items-center"
              tooltip="Editar búsqueda"
              placement="bottom"
              style="
                border: none;
                background-color: transparent;
                width: 50px;
                height: 50px;
                position: absolute;
                top: 0;
                right: 0;
                border-bottom: 1px solid #e0e0e0;
                border-left: 1px solid #e0e0e0;
                border-bottom-left-radius: 5px;
              "
      >
        <img

                          width="35px"
                          height="35px"
                          [ngStyle]="{
                          'fill': headerStyle?.color}"
                          src="../../../assets/icons/itinerary/edit.svg"  alt="">
      </button>
    </div>
  </div>

  <ng-container *ngIf="origin == 'HOTELS' || origin == 'INSURANCE'">

    <div *ngIf="reloadAgain" style="margin-top: 15px !important; margin-bottom: 12px !important; position: relative;">
      <p class="head-title ml-2">Buscando resultados ... <span style="font-size: 18px !important;font-weight: 400 !important;">(Por favor espere, estamos cargando resultados)</span></p>
      <span class="progress" style="width: 100%; height: 6px !important; display: block; overflow: hidden;">
        <span class="progress-bar progress-bar-striped"
              [ngStyle]="{'background-color': headerStyle?.card_line}"
              style="height: 6px !important; width: 100%; position: relative;"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100">
          <span class="indeterminate-progress"></span>
        </span>
      </span>

    </div>

      <div *ngIf="!reloadAgain" class="container-fade-out" style="margin-top: 15px !important; margin-bottom: 12px !important; position: relative;">
      <span class="progress" style="width: 100%; height: 6px !important; display: block;">
        <span class="progress-bar "
              [ngStyle]="{'background-color': headerStyle?.card_line}"
              style="width:100%; height: 6px !important;"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100">
        </span>
      </span>

    </div>
  </ng-container>

    <ng-container *ngIf="origin != 'HOTELS' && origin != 'INSURANCE'">
      <div class="container-fade-out" style="margin-top: 15px !important; margin-bottom: 12px !important; position: relative;">
          <span class="progress" style="width: 100%; height: 6px !important; display: block;">
            <span class="progress-bar "
                  [ngStyle]="{'background-color': headerStyle?.card_line}"
                  style="width:100%; height: 6px !important;"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100">
            </span>
          </span>

        </div>
    </ng-container>

  <!-- FILTROS -->
  <div #filterContainer class="d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center filters" style="margin-bottom: 10px !important; max-height: 42px !important; ">

    <div class="filter" style="max-height: 34px !important;height: 34px !important;width: 31.12%" (click)="openFilter()" [ngStyle]="{'cursor': origin === 'INSURANCE' ? 'pointer' : 'default'}">
      <div class="content-filter d-flex flex-row align-items-center" style="padding: 3px !important;height: 34px !important; max-height: 40px !important; width: 87%; border-radius: 6px; border: 0.73px solid #d3d3d3;">
        <div class="d-flex align-items-center filter-btn" style="width: 100%; font-family: 'Rubik', serif;font-weight: 300;" >
          <i class="i-layer"></i>
          <hr class="vertical-hr-light-dark mx-3 my-0">
          Filtros
        </div>
         <div class="clear-filter d-flex justify-content-end">
          <button class="font-title-group text-center" (click)="clearFilter()"
          [ngStyle]="{'color': headerStyle?.color, 'background-color': headerStyle?.card_line}"
                  style="font-family: 'Rubik', serif;font-weight: 400;width: 100%; height: 28px !important;padding: 0px 15px !important;border-radius: 6px;border:none "
                  > Limpiar
         </button>
        </div>
      </div>
    </div>

    <div class="results-count d-flex align-items-center justify-content-center" style="width: 22.09%;">
      <span class="d-flex flex-column">
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'HOTELS'">{{ resultTotal }} Hoteles</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'TRANSPORTS'">{{ resultPaged?.length }} Traslados</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'RENT-A-CAR'">{{ resultPaged?.length }} Rent a car</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin === 'FLIGHTS'">{{ resultPaged?.length }} Vuelos</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'TOURS' && categoryId === 6">{{ results?.length }} Experiencias</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'TOURS' && categoryId === 9">{{ results?.length }} Tickets</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'INSURANCE'">{{ resultPaged?.length }} Asistencias</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;" *ngIf=" origin == 'BOATS'">{{ resultPaged?.length }} Yates</p>
        <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;">Disponibles</p>
      </span>
    </div>

    <div class="d-flex justify-content-end align-items-center" style="width: 46.79%; gap: .5em;">

      <div #showOrderContainer class="order-by d-flex align-items-center justify-content-center" style="max-height: 34px !important;height: 34px !important; width: 50%;">
        Ordenar por
        <hr class="vertical-hr-light-dark ml-1 mr-2 my-0">
        <div class="select-order d-flex align-items-center" (click)="showOrder=!showOrder">
          {{orderOptions[orderPriceby]}}
          <i class="i-arrow-down ml-2"></i>
        </div>
        <div class="select-options" *ngIf="showOrder">
          <div class="d-flex justify-content-between align-items-center" style="height: 40px !important; padding: 0px 20px !important;">
            Ordernar por:
            <button type="button" class="close" aria-label="Close" (click)="showOrder=!showOrder">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <hr class="m-0">
          <p class="m-0 cursor-pointer" (click)="orderPriceby='priceLow'; filterResults(); showOrder=!showOrder">{{orderOptions['priceLow']}}
          </p>
          <p class="m-0 cursor-pointer" (click)="orderPriceby='priceHigh'; filterResults(); showOrder=!showOrder">
            {{orderOptions['priceHigh']}}</p>
          <!--  <p class="m-0 cursor-pointer" (click)="filterResults(); orderPriceby='masRelevantes';showOrder=!showOrder">{{orderOptions['masRelevantes']}}</p> -->
        </div>
      </div>
        <div *ngIf="!viewMapsResult &&  origin != 'RENT-A-CAR'" class="maps-results cursor-pointer" style="max-height: 34px !important;height: 34px !important; width: 40%"
          (click)="mapMarker(true);">
          <span >Ver Mapa</span>
        </div>
        <div *ngIf="viewMapsResult" class="list-results cursor-pointer" style="max-height: 34px !important;height: 34px !important; width: 45%"
          (click)="mapMarker(false);">
          <span>Ver Lista</span>
        </div>
    </div>


    </div>


  </div>

  <p *ngIf="booleanHideIcons" style="text-align: center;">No se encontraron datos, para los parámetros suministrados!</p>





  <div class="content d-flex" [class.collapsed]="contentCollapsed" *ngIf="!viewMapsResult">

    <div class="filters-container" *ngIf="visualFilter() && results && results.length > 0"
         [ngStyle]="{'position': origin === 'INSURANCE' ? 'absolute' : 'block',
                     'z-index': origin === 'INSURANCE' ? '99999' : 'default'}">
                     <div class="d-flex flex-column " style="width: 100%; margin-top: 1em !important;">
                       <p class="mb-1 ml-4" style="font-family: 'Rubik', serif;font-size: 16px;font-weight: 500;">
                         Filtrado por
                       </p>

                      <div class="chips-container py-1">
                        <ng-container *ngFor="let chip of getFiltersChips()">
                          <div class="chip-filter d-flex align-items-center"
                              [ngStyle]="{'border': '1px solid ' + getClientsSettingAppBooking?.client_setting_global?.color_main_1}">
                            <span class="chip-text ml-2">{{ chip.name }}</span>
                            <!-- <span *ngIf="chip.type !== 'order'"
                                  class="chip-remove mx-2"
                                  (click)="removeFilter(chip)"
                                  [ngStyle]="{'color': getClientsSettingAppBooking.client_setting_global?.color_main_1}"
                                  style="cursor: pointer; font-weight: bold;">✕</span> -->
                          </div>
                        </ng-container>
                      </div>


                       <button *ngIf="origin === 'INSURANCE'" type="button" tooltip="Cerrar filtros" placement="bottom" class="mr-3" style="background-color: transparent;border: none;" (click)="showFilters = false"><i class="fas fa-times"></i></button>
                     </div>

          <div *ngIf="resultsAux && resultsAux.length > 0 && validTotalPrice()" class="group-filter" >
            <div class="form-group" *ngIf="filterLowPrice > 0 && filterHighPrice > 0">


              <hr *ngIf="resultsAux && resultsAux.length > 0 && validTotalPrice()" class="mb-4">
                <label class="ml-1 " style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important">Rango de precios</label>
              <div style=" margin-bottom: .5rem !important;padding-left: .75rem !important; padding-right: .75rem !important">
                 <div class="d-flex justify-content-between">
                  <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;"><b>Min:</b> {{currencyAgency?.code}} {{ filterLowPrice | currencyConverterPure: getCurrencyCategory(resultPaged[0]): currencyAgency.code: currencies | number: '1.2-2' }}</p>
                  <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;"><b>Max:</b> {{currencyAgency?.code}} {{ filterHighPrice | currencyConverterPure: getCurrencyCategory(resultPaged[0]) : currencyAgency.code: currencies | number: '1.2-2' }}</p>
                </div>
                <ngx-slider
                              #ngxSlider
                              (userChangeEnd)="applyFilter($event,'','', '')"
                              style="margin-top: 24px !important;"
                              id="sliderPrice"
                              [(value)]="filterLowPrice"
                              [(highValue)]="filterHighPrice"
                              [options]="optionsSliderPrice"
                > </ngx-slider>


                <span class="d-block w-100 text-right px-2" style="font-family: 'Rubik', serif;font-size: 11px;font-weight: 400;color: black !important"> {{totalProduct}} productos</span>
              </div>
            </div>

        </div>
        <!-- <hr *ngIf="resultsAux && resultsAux.length > 0 && validTotalPrice()" class="m-0"> -->

    <div class="group-filter">


      <!--  FILTROS HOTEL -->

       <label label class="ml-1 " style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'HOTELS' ||  origin == 'TOURS' ||  origin == 'INSURANCE' || origin == 'BOATS'">Nombre</label>
            <div *ngIf="origin == 'HOTELS' || origin == 'TOURS' ||  origin == 'INSURANCE' || origin == 'BOATS'" id="search" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important">
              <div class="row">
                  <div class="col-xg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <input type="text" [(ngModel)]="text" class="form-control" (ngModelChange)="textEmitter($event)">
                      <button type="submit" class="btn d-flex justify-content-end align-items-center mr-2" title="Search"><i class="fas fa-search" style="font-size: 13px;"></i></button>
                  </div>
              </div>
          </div>

          <label class="ml-1 " style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'HOTELS'">Categoría</label>
          <div class="d-flex" style="gap:.75em;margin-bottom: 2.5rem !important;padding-left: 1rem !important; padding-right: 1rem !important" *ngIf="origin == 'HOTELS'">
              <button
                      *ngFor="let starImage of stars(); let i = index"
                      #buttonsStar
                      class="star-button"
                      (click)="filterStar(i)"
                      (mouseenter)="applyStarFilter(i)"
                      (mouseleave)="applyStarFilter(-1)">
                      <img [src]="starImage" class="star-icon">
                    </button>

          </div>
          <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'HOTELS' && mealsFilter && mealsFilter.length > 1" class="mb-4">
          <label class="ml-1 " style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'HOTELS' && mealsFilter && mealsFilter.length > 1">Regimén</label>
          <div  style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important" *ngIf="origin == 'HOTELS' && mealsFilter && mealsFilter.length > 1">
            <div class="d-flex flex-column">
              <div *ngFor="let board of mealsFilter" class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">
                  {{ board.label }}
                </p>
                <input
                  #filterCheckbox
                  class="mb-2 board-checkbox"
                  type="checkbox"
                  [value]="board.key"
                  (click)="filterTypeBoardName($event.target.checked, board.key)">
              </div>
            </div>
          </div>

          <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'HOTELS'" class="mb-4">

          <label class="ml-1 " style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'HOTELS'">Cancelación</label>
          <div  style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important" *ngIf="origin == 'HOTELS'">
            <div class="d-flex flex-column">
              <div class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">Reembolsable</p>
                <input #filterCheckbox class="mb-2 cancellation-checkbox" type="checkbox" [value]="'R'" (click)="filterTypeRate($event.target.checked, $event.target.value)">
              </div>
              <div class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">No reembolsable</p>
                <input #filterCheckbox class="mb-2 cancellation-checkbox" type="checkbox" [value]="'NR'" (click)="filterTypeRate($event.target.checked, $event.target.value)">
              </div>
            </div>
          </div>

          <hr *ngIf="resultsAux && resultsAux.length > 0 && (origin == 'HOTELS' || origin == 'TOURS') && amenitiesFilter.length > 1" class="mb-4">

            <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="(origin == 'HOTELS' || origin == 'TOURS') && amenitiesFilter && amenitiesFilter.length > 1">Amenities</label>
            <div  style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="(origin == 'HOTELS' || origin == 'TOURS') && amenitiesFilter && amenitiesFilter.length > 1">
              <ng-container *ngFor="let amenity of amenitiesFilter">
                  <div class="d-flex align-center mb-2 justify-content-between">
                    <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ amenity.label }}</p>
                    <input
                            #filterCheckbox
                            class="amenity-checkbox"
                            type="checkbox"
                            [value]="amenity.label"
                            (change)="filterAmenities($event.target.checked, amenity.key)">
                  </div>
                </ng-container>
            </div>


            <!--  FILTROS TRASLADO -->

             <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'TRANSPORTS' && vehicleTypeFilter.length > 1" class="mb-4">

            <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'TRANSPORTS' && vehicleTypeFilter && vehicleTypeFilter.length > 1">Tipo de vehículo</label>
            <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'TRANSPORTS' && vehicleTypeFilter && vehicleTypeFilter.length > 1">
              <ng-container *ngFor="let type of vehicleTypeFilter">
                  <div class="d-flex align-center mb-2 justify-content-between">
                    <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}</p>
                    <input
                            #filterCheckbox type="checkbox"
                            class="vehicle-checkbox"
                            [value]="type.label"
                            (change)="filterFx($event.target.checked, type.key, vehicleTypeFilter, 'vehicle.type', 'vehicles')">
                  </div>
                </ng-container>
            </div>

             <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'TRANSPORTS' && vehicleServiceFilter.length > 1" class="mb-4">

             <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'TRANSPORTS'">Tipo de traslado</label>
            <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'TRANSPORTS'">
              <ng-container *ngFor="let service of vehicleServiceFilter">
                  <div class="d-flex align-center mb-2 justify-content-between">
                    <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ service.label }}</p>
                    <input
                            #filterCheckbox type="checkbox"
                            class="service-checkbox"
                            [value]="service.label"
                            (change)="filterFx($event.target.checked, service.key, vehicleServiceFilter, 'transferType', 'vehicles')">
                  </div>
                </ng-container>
            </div>

              <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'TOURS' && languageFilter.length > 1" class="mb-4">

            <!-- Filtros tours -->
            <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'TOURS' && languageFilter && languageFilter.length > 1">Idioma</label>
            <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'TOURS' && languageFilter && languageFilter.length > 1">
              <ng-container *ngFor="let type of languageFilter">
                  <div class="d-flex align-center mb-2 justify-content-between">
                    <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}</p>
                    <input
                            #filterCheckbox type="checkbox"
                            class="language-checkbox"
                            [value]="type.label"
                            (change)="filterFx($event.target.checked, type.key, languageFilter, 'language', 'additionalInfo.tours.options')">
                  </div>
                </ng-container>
            </div>

               <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'TOURS' && payload?.categoriesId[0] === 6" class="mb-4">

            <label class="ml-1 "
              style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important"
              *ngIf="origin == 'TOURS' && payload?.categoriesId[0] === 6">Cancelación
            </label>
            <div
              style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important"
              *ngIf="origin == 'TOURS' && payload?.categoriesId[0] === 6">
              <div class="d-flex flex-column">
                <div class="d-flex align-center mb-2 justify-content-between">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">Reembolsable</p>
                  <input #filterCheckbox class="mb-2 cancellation-checkbox" type="checkbox" [value]="'R'"
                    (click)="filterTypeRate($event.target.checked, $event.target.value)">
                </div>
                <div class="d-flex align-center mb-2 justify-content-between">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">No reembolsable
                  </p>
                  <input #filterCheckbox class="mb-2 cancellation-checkbox"  type="checkbox" [value]="'NR'"
                    (click)="filterTypeRate($event.target.checked, $event.target.value)">
                </div>
              </div>
            </div>

               <hr *ngIf="resultsAux && resultsAux.length > 0 && origin == 'TOURS' && sessionsFilter.length > 1" class="mb-4">

             <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'TOURS' && sessionsFilter && sessionsFilter.length > 1">Horario</label>
            <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'TOURS' && sessionsFilter && sessionsFilter.length > 1">

              <ng-container *ngFor="let type of sessionsFilter">
                  <div class="d-flex align-center mb-2 justify-content-between">
                    <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}</p>
                    <input
                            #filterCheckbox type="checkbox"
                            class="schedule-checkbox"
                            [value]="type.label"
                            (change)="filterFx($event.target.checked, type.key, sessionsFilter, 'sessions', 'additionalInfo.tours.options')">
                  </div>
                </ng-container>
            </div>
        </div>

        <!--  FILTROS VUELOS -->

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && stopsFilterFlights.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && stopsFilterFlights.length > 0">Escalas</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && stopsFilterFlights.length > 0">
          <ng-container *ngFor="let stop of stopsFilterFlights">
            <div class="d-flex align-center mb-2 justify-content-between">
              <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ stop.label }} ({{ stop.count }})</p>
              <input #filterCheckbox type="checkbox" [value]="stop.key"
                (change)="toggleFlightStops($event.target.checked, stop.key)">
            </div>
          </ng-container>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && airlinesFilterFlights.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && airlinesFilterFlights.length > 0">Aerolíneas</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && airlinesFilterFlights.length > 0">
          <ng-container *ngFor="let airline of (showAllAirlinesFlights ? airlinesFilterFlights : airlinesFilterFlights.slice(0, 6))">
            <div class="d-flex align-center mb-2 justify-content-between">
              <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ airline.label }} ({{ airline.count }})</p>
              <input #filterCheckbox type="checkbox" [value]="airline.key"
                (change)="toggleFlightAirline($event.target.checked, airline.key)">
            </div>
          </ng-container>
          <p *ngIf="airlinesFilterFlights.length > 6" class="mb-0 ml-1"
             style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 500; text-decoration: underline; cursor: pointer;"
             (click)="showAllAirlinesFlights = !showAllAirlinesFlights">
            {{ showAllAirlinesFlights ? 'Ver menos' : 'Ver más' }}
          </p>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && cabinClassFilterFlights.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && cabinClassFilterFlights.length > 0">Clase preferida</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && cabinClassFilterFlights.length > 0">
          <ng-container *ngFor="let cabin of cabinClassFilterFlights">
            <div class="d-flex align-center mb-2 justify-content-between">
              <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ cabin.label }} ({{ cabin.count }})</p>
              <input #filterCheckbox type="checkbox" [value]="cabin.key"
                (change)="toggleFlightCabinClass($event.target.checked, cabin.key)">
            </div>
          </ng-container>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && flightAttributesFilter.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && flightAttributesFilter.length > 0">Viaje y equipaje</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && flightAttributesFilter.length > 0">
          <ng-container *ngFor="let attribute of flightAttributesFilter">
            <div class="d-flex align-center mb-2 justify-content-between">
              <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ attribute.label }} ({{ attribute.count }})</p>
              <input #filterCheckbox type="checkbox" [value]="attribute.key"
                (change)="toggleFlightAttribute($event.target.checked, attribute.key)">
            </div>
          </ng-container>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && flightDurationRangeHours.max > flightDurationRangeHours.min" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && flightDurationRangeHours.max > flightDurationRangeHours.min">Tiempo total de viaje</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && flightDurationRangeHours.max > flightDurationRangeHours.min">
          <p class="mb-0 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">
            Menos de {{ selectedMaxDurationHoursFlights }} hs
          </p>
          <ngx-slider
                        #ngxSliderDuration
                        (userChange)="applyAllFilters()"
                        style="margin-top: 8px !important;"
                        id="sliderDuration"
                        [(value)]="selectedMaxDurationHoursFlights"
                        [options]="optionsSliderDuration">
          </ngx-slider>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && departureTimeFilterFlights.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && departureTimeFilterFlights.length > 0">Hora de salida</label>
        <div class="flight-time-grid" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && departureTimeFilterFlights.length > 0">
          <div *ngFor="let bucket of departureTimeFilterFlights"
               class="flight-time-box"
               [class.selected]="selectedDepartureTimeFlights.includes(bucket.key)"
               (click)="toggleFlightDepartureTime(bucket.key)">
            <span class="flight-time-icon">{{ bucket.icon }}</span>
            <span class="flight-time-label">{{ bucket.label }}</span>
            <span class="flight-time-range">{{ bucket.range }}</span>
          </div>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && arrivalTimeFilterFlights.length > 0" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && arrivalTimeFilterFlights.length > 0">Hora de llegada</label>
        <div class="flight-time-grid" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && arrivalTimeFilterFlights.length > 0">
          <div *ngFor="let bucket of arrivalTimeFilterFlights"
               class="flight-time-box"
               [class.selected]="selectedArrivalTimeFlights.includes(bucket.key)"
               (click)="toggleFlightArrivalTime(bucket.key)">
            <span class="flight-time-icon">{{ bucket.icon }}</span>
            <span class="flight-time-label">{{ bucket.label }}</span>
            <span class="flight-time-range">{{ bucket.range }}</span>
          </div>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && origin === 'FLIGHTS' && departureAirportsFilterFlights.length > 1" class="mb-4">

        <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin === 'FLIGHTS' && departureAirportsFilterFlights.length > 1">Aeropuertos de salida</label>
        <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin === 'FLIGHTS' && departureAirportsFilterFlights.length > 1">
          <ng-container *ngFor="let airport of departureAirportsFilterFlights">
            <div class="d-flex align-center mb-2 justify-content-between">
              <p class="mb-2 ml-1" style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ airport.label }} ({{ airport.count }})</p>
              <input #filterCheckbox type="checkbox" [value]="airport.key"
                (change)="toggleFlightDepartureAirport($event.target.checked, airport.key)">
            </div>
          </ng-container>
        </div>

        <hr *ngIf="resultsAux && resultsAux.length > 0 && luggageFilter.length > 0" class="mb-4">
        <!-- FILTROS RENTACAR -->
          <label *ngIf="luggageFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" >Tipo de Maletero</label>

          <div *ngIf="luggageFilter.length > 0 && origin == 'RENT-A-CAR'" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" >
            <ng-container *ngFor="let type of luggageFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1"
                  style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                </p>
                <input #filterCheckbox  type="checkbox" [value]="type.label"
                  (change)="filterLuggage($event.target.checked, type.key)">
              </div>
            </ng-container>
          </div>

           <hr *ngIf="resultsAux && resultsAux.length > 0 && acrissFilter.length > 0" class="mb-4">

           <label *ngIf="acrissFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important">Tipo de Vehículo</label>

          <div *ngIf="acrissFilter.length > 0 && origin == 'RENT-A-CAR'" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" >
            <ng-container *ngFor="let type of acrissFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1"
                  style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                </p>
                <input #filterCheckbox type="checkbox" [value]="type.label"
                  (change)="filterAcriss($event.target.checked, type.key)">
              </div>
            </ng-container>
          </div>

                  <hr *ngIf="resultsAux && resultsAux.length > 0 && supplierContractRentACarFilter.length > 0" class="mb-4">

          <label *ngIf="supplierContractRentACarFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" >Rentadora</label>

          <div *ngIf="supplierContractRentACarFilter.length > 0 && origin == 'RENT-A-CAR'" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" >
            <ng-container *ngFor="let type of supplierContractRentACarFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <div class="d-flex align-items-center">
                  <img src="{{type.logo}}" class="mb-2 ml-1" style="width: 65px; height: 20px;" alt="">
                  <!-- <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                  </p> -->
                </div>

                <input #filterCheckbox type="checkbox" [value]="type.label"
                  (change)="filterSuplierRentACar($event.target.checked, type.key)">
              </div>
            </ng-container>
          </div>

          <hr *ngIf="resultsAux && resultsAux.length > 0 && transmissionFilter.length > 0" class="mb-4">

          <label *ngIf="transmissionFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" >Transmisión</label>

          <div *ngIf="transmissionFilter.length > 0 && origin == 'RENT-A-CAR'" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" >
            <ng-container *ngFor="let type of transmissionFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <label class="checkbox-label">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                  </p>

                  <input #filterCheckbox type="checkbox" [value]="type.label" style="visibility: hidden;"
                    (change)="filterTransmission($event.target.checked, type.key)">
                </label>
              </div>
            </ng-container>
          </div>

            <hr *ngIf="resultsAux && resultsAux.length > 0 && quantityDoorsFilter.length > 0" class="mb-4">

           <label *ngIf="quantityDoorsFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" >Puertas</label>

          <div style="margin-bottom: 1rem !important; padding-left: 1rem !important; padding-right: 3rem !important; display: grid; grid-template-columns: repeat(3, 1fr); gap: 3px;" *ngIf="origin == 'RENT-A-CAR'">
            <ng-container *ngFor="let type of quantityDoorsFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <label class="checkbox-label">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d">{{ type.label }}
                  </p>

                  <input #filterCheckbox type="checkbox" [value]="type.label" style="visibility: hidden;"
                    (change)="filterDoors($event.target.checked, type.key)">
                </label>
              </div>
            </ng-container>

          </div>

          <hr *ngIf="resultsAux && resultsAux.length > 0 && quantityMaxPassengerFilter.length > 0" class="mb-4">

          <label *ngIf="quantityMaxPassengerFilter.length > 0 && origin == 'RENT-A-CAR'" class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" >Cantidad máx. pasajeros</label>

          <div *ngIf="quantityMaxPassengerFilter.length > 0 && origin == 'RENT-A-CAR'"
                style="margin-bottom: 1rem !important; padding-left: 1rem !important; padding-right: 6.5rem !important; display: grid; grid-template-columns: repeat(2, 1fr); gap: 3px;">
            <ng-container *ngFor="let type of quantityMaxPassengerFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <label class="checkbox-label">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d">{{ type.label }}
                  </p>

                  <input #filterCheckbox type="checkbox" [value]="type.label" style="visibility: hidden;"
                    (change)="filterMaxPassenger($event.target.checked, type.key)">
                </label>
              </div>
            </ng-container>
          </div>




          <!-- Filtros asistencia  -->


           <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'INSURANCE'">Modalidad</label>

          <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'INSURANCE'">
            <ng-container *ngFor="let type of modalityFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <p class="mb-2 ml-1"
                  style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                </p>
                <input #filterCheckbox type="checkbox" [value]="type.label"
                  (change)="filterAcriss($event.target.checked, type.key)">
              </div>
            </ng-container>
          </div>

          <!-- <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'INSURANCE'">Cobertura</label>

          <div style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important;" *ngIf="origin == 'INSURANCE'">
            <ng-container *ngFor="let type of coverageFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <label class="checkbox-label">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d !important">{{ type.label }}
                  </p>

                  <input #filterCheckbox type="checkbox" [value]="type.label" style="visibility: hidden;"
                    (change)="filterTransmission($event.target.checked, type.key)">
                </label>
              </div>
            </ng-container>
          </div>

           <label class="ml-1" style="font-family: 'Rubik', serif;font-size: 17px;font-weight: 400;padding-left: 1rem !important; padding-right: 1rem !important;color: black !important" *ngIf="origin == 'INSURANCE'">Adicionales</label>

          <div class="d-flex" style="margin-bottom: 1rem !important;padding-left: 1rem !important; padding-right: 1rem !important; gap: 3px;" *ngIf="origin == 'INSURANCE'">
            <ng-container *ngFor="let type of upgradesFilter">
              <div class="d-flex align-center mb-2 justify-content-between">
                <label class="checkbox-label">
                  <p class="mb-2 ml-1"
                    style="font-family: 'Rubik',serif ;font-size: 13px;font-weight: 400; color: #55637d">{{ type.label }}
                  </p>

                  <input #filterCheckbox type="checkbox" [value]="type.label" style="visibility: hidden;"
                    (change)="filterDoors($event.target.checked, type.key)">
                </label>
              </div>
            </ng-container>
          </div> -->


      </div>
      <div class="d-flex flex-column" style="margin-left: 9px !important;"
            [ngStyle]="{'width': origin === 'HOTELS' ?
                                '80%' :
                                origin === 'INSURANCE' ?
                                '100%' :
                                 origin === 'TRANSPORTS' || origin === 'RENT-A-CAR' ?
                                '70%' :
                               '80%' }">

        <!-- INICIO DE RESULTADOS MULTIDESTINO -->
        <div *ngIf="origin=='MULTIDESTINATION'">
          <div *ngIf="(tabSelected==='HOTELS')">
            <div *ngIf="(resultPaged?.length > 0) else noResultsFound">
              <div *ngFor="let item of resultPaged; let i = index; trackBy: trackByProductId">
                <usb-base-result
                      #containerResults
                      id="containerResults"
                      [result]="item"
                      [views]="item?.view_hotel"
                      [currencyAgency]="currencyAgency"
                      [clientsSettingAppBooking]="getClientsSettingAppBooking"
                      [payload]="payload"
                      [currencies]="currencies"
                      [paymentAgencyActive]="paymentAgencyActive"
                      [arrayResults]="results"
                      [form]="_form"
                      [qtyProductValid]="qtyProductValid"
                      [stylePathPrice]="stylePathPrice"
                      [index]="i"
                      (qtyProductValidDecrementEmmitChild)="qtyProductValidDecrement()"
                      (modalClosedemitterChild)="modalClosedemitter($event)"
                      (mouseenter)="onMouseEnter($event)"
                      (mouseleave)="onMouseLeave($event)"
                    >
                </usb-base-result>
              </div>
            </div>
          </div>



          <!-- RESULTADOS DE TRANSPORTS MULTIDESTINATION  -->
          <div *ngIf="tabSelected==='TRANSPORTS'" >
            <div *ngIf="(resultPaged?.length > 0) else noResultsFound">
              <div *ngFor="let item of resultPaged; let i = index; trackBy: trackByProductId">
                <usb-base-result
                                  #containerResults
                                  id="containerResults"
                                  [arrayResults]="results"
                                  [result]="item"
                                   [views]="item?.views"
                                  [payload]="payload"
                                  [stylePathPrice]="stylePathPrice"
                                  [index]="i"
                                  [form]="_form"
                                  [formTransports]="formTransports"
                                  [currencies]="currencies"
                                  [currencyAgency]="currencyAgency"
                                  [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                  [_actualItinerary]="_actualItinerary"
                                  [paymentAgencyActive]="paymentAgencyActive"
                                  (modalClosedemitterChild)="modalClosedemitter($event)"
                  >
                  </usb-base-result>
              </div>
            </div>
          </div>
          <!-- RESULTADOS DE TOURS  -->
          <div *ngIf="tabSelected==='TOURS'">
            <div *ngIf="(resultPaged?.length > 0) else noResultsFound">
              <div *ngFor="let item of resultPaged; let i = index; trackBy: trackByProductId">
                 <usb-base-result
                                  #containerResults
                                  id="containerResults"
                                  [views]="item?.views"
                                  [currencies]="currencies"
                                  [stylePathPrice]="stylePathPrice"
                                  [currencyAgency]="currencyAgency"
                                  [arrayResults]="resultsAux"
                                  [paymentAgencyActive]="paymentAgencyActive"
                                  [result]="item"
                                  [payload]="payload"
                                  [index]="i"
                                  [form]="_form"
                                  [clientsSettingAppBooking]="getClientsSettingAppBooking"
                >
                </usb-base-result>
              </div>
            </div>
          </div>
          <!-- SUMMARY ITINERARY  -->
          <div *ngIf="tabSelected==='SUMMARY'">
            <usb-itinerary-summary></usb-itinerary-summary>
          </div>
        </div>
        <!-- FIN DE RESULTADOS MULTIDESTINO -->


        <!-- INICIO DE RESULTADOS INDIVIDUALES -->
        <!-- RESULTADOS DE HOTELES | paginate: { itemsPerPage: 20, currentPage: page } -->

          <div *ngIf="origin==='HOTELS' && !viewMapsResult && resultPaged && resultPaged.length>0" >
            <div *ngFor="let resultHotel of resultPaged; let gi = index; trackBy: trackByIndex">
              <ng-container *ngFor="let item of resultHotel | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
                <ng-container *ngIf="item.additionalInfo">
                  <usb-base-result
                      #containerResults
                      id="containerResults"
                      [result]="item"
                      [views]="item?.views"
                      [currencyAgency]="currencyAgency"
                      [stylePathPrice]="stylePathPrice"
                      [clientsSettingAppBooking]="getClientsSettingAppBooking"
                      [payload]="payload"
                      [currencies]="currencies"
                      [paymentAgencyActive]="paymentAgencyActive"
                      [arrayResults]="results"
                      [form]="_form"
                      [qtyProductValid]="qtyProductValid"
                      [index]="i"
                      (qtyProductValidDecrementEmmitChild)="qtyProductValidDecrement()"
                      (modalClosedemitterChild)="modalClosedemitter($event)"
                      (mouseenter)="onMouseEnter($event)"
                      (mouseleave)="onMouseLeave($event)"
                    >
                  </usb-base-result>
                </ng-container>
              </ng-container>
            </div>
          </div>

            <!-- RESULTADOS DE RENT A CAR  -->

          <div *ngIf="origin==='RENT-A-CAR' && !viewMapsResult && resultPaged.length>0" >
            <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
              <usb-base-result
                               #containerResults
                               id="containerResults"
                               [views]="item?.views"
                               [currencies]="currencies"
                               [currencyAgency]="currencyAgency"
                               [stylePathPrice]="stylePathPrice"
                               [arrayResults]="resultsAux"
                               [paymentAgencyActive]="paymentAgencyActive"
                               [result]="item"
                               [payload]="payload"
                               [index]="i"
                               [form]="_form"
                               [clientsSettingAppBooking]="getClientsSettingAppBooking"
                               (modalClosedemitterChild)="modalClosedemitter($event)"
              >
              </usb-base-result>
            </div>
          </div>

           <!-- RESULTADOS DE VUELOS  -->
          <div *ngIf="origin==='FLIGHTS' && !viewMapsResult" >

            <!-- Pestañas: vuelo completo (hoy) vs. elegir por tramo -->
            <div *ngIf="resultPaged && resultPaged.length>0 && payload?.legs.length > 1" class="d-flex" style="gap: 8px; margin-bottom: 1rem !important;">
              <button
                type="button"
                (click)="flightViewMode = 'full'"
                [style.background-color]="flightViewMode === 'full' ? '#00d398' : '#f1f1f1'"
                [style.color]="flightViewMode === 'full' ? '#ffffff' : '#333333'"
                style="border: none; border-top-left-radius: 6px;border-top-right-radius: 6px; padding: 0.4rem 1.2rem; font-family: 'Rubik'; font-size: 14px; font-weight: 600;width: 100%;cursor: pointer"
              >
                Vuelo completo
              </button>
              <button
                type="button"
                (click)="flightViewMode = 'byLeg'"
                [style.background-color]="flightViewMode === 'byLeg' ? '#00d398' : '#f1f1f1'"
                [style.color]="flightViewMode === 'byLeg' ? '#ffffff' : '#333333'"
                style="border: none; border-top-left-radius: 6px;border-top-right-radius: 6px; padding: 0.4rem 1.2rem; font-family: 'Rubik'; font-size: 14px; font-weight: 600;width: 100%;cursor: pointer"
              >
                Por tramos
              </button>
            </div>

            <usb-flight-legs-search
              *ngIf="flightViewMode === 'byLeg'"
              [payload]="payload"
              [arrayResults]="results"
              [currencies]="currencies"
              [currencyAgency]="currencyAgency"
              [paymentAgencyActive]="paymentAgencyActive"
              [clientsSettingAppBooking]="getClientsSettingAppBooking"
              [qtyProductValid]="qtyProductValid"
              (productAdded)="qtyProductValidDecrement(); modalClosedemitter('success')"
            >
            </usb-flight-legs-search>

            <ng-container *ngIf="flightViewMode === 'full' && resultPaged && resultPaged.length>0">
              <ng-container *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
                  <usb-base-result
                                    #containerResults
                                    id="containerResults"
                                    [arrayResults]="results"
                                    [result]="item"
                                    [payload]="payload"
                                    [index]="i"
                                    [form]="_form"
                                    [currencies]="currencies"
                                    [currencyAgency]="currencyAgency"
                                    [paymentAgencyActive]="paymentAgencyActive"
                                    [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                    (modalClosedemitterChild)="modalClosedemitter($event)"
                                    (qtyProductValidDecrementEmmitChild)="qtyProductValidDecrement()"
                                    [qtyProductValid]="qtyProductValid">
                  </usb-base-result>
              </ng-container>
            </ng-container>
          </div>

        <!-- RESULTADOS DE TOURS  -->
        <div *ngIf="origin==='TOURS' && !viewMapsResult && resultPaged.length>0" >
          <div *ngFor="let item of results | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
              <usb-base-result
                                  #containerResults
                                  id="containerResults"
                                  [views]="item?.views"
                                  [currencies]="currencies"
                                  [currencyAgency]="currencyAgency"
                                  [stylePathPrice]="stylePathPrice"
                                  [arrayResults]="resultsAux"
                                  [paymentAgencyActive]="paymentAgencyActive"
                                  [result]="item"
                                  [payload]="payload"
                                  [index]="i"
                                  [form]="_form"
                                  [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                   (modalClosedemitterChild)="modalClosedemitter($event)"
              >
              </usb-base-result>
          </div>
        </div>
        <!-- RESULTADOS DE CRUISES  -->
        <div *ngIf="origin==='CRUISES' && !viewMapsResult && resultPaged.length>0">
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-cruises-result [arrayResults]="results" [result]="item" [payload]="payload" [index]="i" [form]="results.form"
              [origin]="origin"></usb-cruises-result>
          </div>
        </div>

        <!-- [ngClass]="{ 'hidden': !resultReload, 'visible': resultReload, 'opacityTransition': true }" -->
        <!-- RESULTADOS DE TRANSPORTS PARA EL HOME  -->
        <div *ngIf="origin==='TRANSPORTS' && !viewMapsResult && resultPaged &&  resultPaged?.length>0" >
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-base-result
                                  #containerResults
                                  id="containerResults"
                                  [arrayResults]="results"
                                  [result]="item"
                                   [views]="item?.views"
                                  [payload]="payload"
                                  [stylePathPrice]="stylePathPrice"
                                  [index]="i"
                                  [form]="_form"
                                  [formTransports]="formTransports"
                                  [currencies]="currencies"
                                  [currencyAgency]="currencyAgency"
                                  [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                  [_actualItinerary]="_actualItinerary"
                                  [paymentAgencyActive]="paymentAgencyActive"
                                  (modalClosedemitterChild)="modalClosedemitter($event)"
            >
            </usb-base-result>
          </div>
        </div>
        <!-- RESULTADOS DE YATES  -->
        <div *ngIf="origin==='BOATS' && !viewMapsResult && resultPaged?.length>0" >
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-base-result
                                  #containerResults
                                  id="containerResults"
                                  [arrayResults]="results"
                                  [result]="item"
                                  [views]="item?.views"
                                  [payload]="payload"
                                  [stylePathPrice]="stylePathPrice"
                                  [index]="i"
                                  [form]="_form"
                                  [currencies]="currencies"
                                  [currencyAgency]="currencyAgency"
                                  [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                  [paymentAgencyActive]="paymentAgencyActive"
                                  (modalClosedemitterChild)="modalClosedemitter($event)"
            >
            </usb-base-result>
          </div>
        </div>
        <!-- RESULTADOS DE PACKAGES  -->
        <div *ngIf="origin==='PACKAGES'" >
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-packages-result [arrayResults]="results" [result]="item" [payload]="payload" [index]="i" [form]="results.form"
              [origin]="origin"></usb-packages-result>
          </div>
        </div>
        <!-- RESULTADOS DE DISNEY  -->
        <div *ngIf="origin==='DISNEY' && !viewMapsResult && resultPaged.length>0" >
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-disney-result [arrayResults]="results" [result]="item" [payload]="payload" [index]="i" [form]="results.form" [origin]="origin">
            </usb-disney-result>
          </div>
        </div>
        <!-- RESULTADOS DE PTHEMES  -->
        <div *ngIf="origin==='PTHEMES' && !viewMapsResult && resultPaged.length>0" >
          <div *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-p-themes-result [arrayResults]="results" [result]="item" [payload]="payload" [index]="i" [form]="results.form"
              [origin]="origin" [imageItem]="getUrlImagePark(item.title)"></usb-p-themes-result>
          </div>
        </div>
        <!-- RESULTADOS DE INSURANCE  -->
        <div *ngIf="origin==='INSURANCE'&& !viewMapsResult && resultPaged.length>0" >
          <div #insuranceResult *ngFor="let item of resultPaged | paginate: { itemsPerPage: 10, currentPage: page }; let i = index; trackBy: trackByProductId">
            <usb-insurance-result
                                    [arrayResults]="results"
                                    [result]="item"
                                    [payload]="payload"
                                    [index]="i"
                                    [form]="_form"
                                    [paxesSelected]="paxesSelected[i]"
                                    [paxesAvailability]="getPaxesDisponiblesParaHijo(i)"
                                    (paxesChange)="onPaxesChange(i, $event)"
                                    (selectPlanSelectedCompareEmmit)="onPlanSelectCompare($event)"
                                    [currencies]="currencies"
                                    [currencyAgency]="currencyAgency"
                                    [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                    [origin]="origin"
                                    [disbaledCompare]="disbaledCompare"
                                    (toCompare)="toCompare()"
                                    (addToCompare)="addToCompare($event)"
                                    [_itemToCompare]="itemToCompare"></usb-insurance-result>
          </div>
        </div>





        <!-- paginacion   (pageChange)="page = $event" -->
        <div class="d-flex justify-content-end align-items-center nav-pagination" *ngIf="!viewMapsResult && !booleanHideIcons">
          <pagination-controls
                                  *ngIf="resultTotal >= 10"
                                  class="pt-3"
                                  previousLabel=""
                                  nextLabel=""
                                  (pageChange)="onPageChange($event)">
          </pagination-controls>
        </div>
        <!-- *ngIf="resultTotal >= 10"  -->


      </div>
  </div>


  <ng-template #noResultsFound>
    <div class="col-12 pt-10 text-center">
      <h4>No results found for this search.</h4>
    </div>
  </ng-template>
</div>
